import { gql } from '@apollo/client';
import {
  CbAccountBalanceFields,
  CbBalanceTransactionFields,
} from './fragments';

export const GET_CB_ACCOUNT_BALANCE = gql`
  query GetCbAccountBalance($input: GetCbAccountBalanceInput!) {
    getCbAccountBalance(input: $input) {
      ...CbAccountBalanceFields
    }
  }
  ${CbAccountBalanceFields}
`;

export const GET_CB_BALANCE_TRANSACTIONS = gql`
  query GetCbBalanceTransactions($input: GetCbBalanceTransactionsInput!) {
    getCbBalanceTransactions(input: $input) {
      entities {
        ...CbBalanceTransactionFields
      }
      total
      offset
      limit
    }
  }
  ${CbBalanceTransactionFields}
`;
